import styled from "styled-components";

export const BackButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 0;
    margin-bottom: 24px;
    background: none;
    border: none;
    cursor: pointer;
    font: inherit;
    font-size: 16px;
    font-style: italic;
    font-weight: 500;
    color: #262626;

    &:hover span:last-child {
        text-decoration: underline;
    }

    &:hover .back-icon {
        background: #c8102e;
    }
`;

export const BackIconCircle = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #e30a17;
    color: #fff;
    font-size: 16px;
    transition: background 0.2s;
`;
